var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"ifr","src":"/Elsa.html","sandbox":"allow-forms allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }